import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchApps } from "../../../actions/community/appsActions";
import { setNewParams } from "src/store/community/appsSlice";

import New from "./New";
import Edit from "./Edit";
import ListTable from "./_partials/_ListTable";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "src/componets/Wrapper";
import Filter from "src/componets/Filter";
import PageLayout from "src/pages/_partials/Layout/PageLayout";
import NavBarThree from "../../../componets/NavBarThree";
import Can from "../../../componets/Can";
import { PlusOutlined } from "@ant-design/icons";

import './style.scss';

const LIMIT = 42;

const Apps = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { pathname } = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchApps(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  function onClickCreate() {
    dispatch(setNewParams({}));
  }

  return (
    <PageLayout className='v-apps'>
      <PageHeader
        title='Apps'
        align='right'
      />

      <Can capability='write_community'>
        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
              <PlusOutlined /> Create App
            </NavBarThree.Button>
          </NavBarThree>
        </Wrapper>
      </Can>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={{
              items: [
                { name: 'Date', key: 'id' },
                { name: 'Name', key: 'name' },
              ]
            }}
          />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <New />
      <Edit />
    </PageLayout>
  );
}

export default Apps;
